import { Coins, Gift, UserPlus } from "lucide-react";

const Stat = ({ icon: Icon, label, value, testId }) => (
  <div className="flex-1 min-w-[8.5rem] rounded-2xl bg-white/15 ring-1 ring-white/30 px-3 py-2.5 flex items-center gap-2.5">
    <Icon className="w-5 h-5 shrink-0 text-amber-200" />
    <div className="min-w-0">
      <p className="text-[11px] font-semibold text-white/80 leading-tight">{label}</p>
      <p className="font-display font-extrabold text-lg leading-tight" data-testid={testId}>{value}</p>
    </div>
  </div>
);

export const InviteBonusHero = ({ data }) => (
  <section className="relative overflow-hidden rounded-[2rem] pink-gradient text-white p-5 sm:p-7 shadow-xl shadow-rose-200" data-testid="invite-bonus-hero">
    <span className="contest-shine" aria-hidden />
    <div className="relative flex items-center gap-4 sm:gap-6">
      <span className="w-16 h-16 sm:w-20 sm:h-20 rounded-3xl bg-gradient-to-br from-amber-200 to-amber-400 text-amber-900 flex items-center justify-center shrink-0 shadow-lg animate-[pulse_2.4s_ease-in-out_infinite]">
        <Coins className="w-9 h-9 sm:w-11 sm:h-11" strokeWidth={2.2} />
      </span>
      <div className="min-w-0">
        <p className="text-xs font-extrabold uppercase tracking-[0.25em] text-white/85">Für jeden Freund</p>
        <p className="font-display font-black leading-none text-6xl sm:text-7xl tracking-tight drop-shadow" data-testid="invite-bonus-points">+{data.points_per_friend}</p>
        <p className="mt-1 text-sm sm:text-base font-bold">Punkte – sofort, sobald dein Freund sich registriert</p>
      </div>
    </div>
    <div className="relative mt-5 flex flex-wrap gap-2.5">
      {data.friend_welcome > 0 && <Stat icon={Gift} label="Dein Freund bekommt" value={`+${data.friend_welcome} Startbonus`} testId="invite-bonus-friend" />}
      <Stat icon={UserPlus} label="Schon verdient" value={`${data.earned.toLocaleString("de-DE")} Punkte`} testId="invite-bonus-earned" />
    </div>
  </section>
);
